import React from 'react'
import { useLoader } from './LoaderContext'
import './globalloader.css'

function GlobalLoader() {
    const {loading} = useLoader();

  return loading ?(
    <div className="global-loader">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  ) : null;
}

export default GlobalLoader